import DatatablesController from '../../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns() {
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'name',
        title: 'Nama Badge',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.name}</span>`;
        }
      },
      {
        field: 'badge_type',
        title: 'Tipe',
        overflow: 'visible',
        autoHide: false,
        width: 90,
        template: function(data) {
          const colors = { bronze: 'warning', silver: 'secondary', gold: 'danger' };
          const color = colors[data.badge_type] || 'light';
          return `<span class="badge badge-${color}">${data.badge_type || '-'}</span>`;
        }
      },
      {
        field: 'description',
        title: 'Deskripsi',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="text-muted">${data.description || '-'}</span>`;
        }
      },
      {
        field: 'users_count',
        title: 'Pengguna',
        overflow: 'visible',
        autoHide: false,
        width: 80,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.users_count}</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Aksi',
        sortable: false,
        width: 100,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Lihat">
              <i class="fa fa-eye text-primary"></i>
            </a>
            <a class="btn btn-sm btn-clean btn-icon" href="${data.edit_path}" title="Edit">
              <i class="fa fa-edit text-warning"></i>
            </a>
            <a class="btn btn-sm btn-clean btn-icon" href="${data.delete_path}"
               data-method="delete" data-confirm="Hapus badge ini?" title="Hapus">
              <i class="fa fa-trash text-danger"></i>
            </a>
          `;
        }
      }
    ];
  }
}
